import { readonly, ref } from "vue";

const selection = ref("personal");
let switching = false;
let account = "";
export const activeWorkspace = readonly(selection);
export function isWorkspaceSwitchPending() {
  return switching;
}

export function initializeWorkspace(email = "") {
  if (account === email) return;
  account = email;
  selection.value = "personal";
  if (!account) return;
  try {
    selection.value =
      localStorage.getItem(`permitpilott:workspace:${account}`) || "personal";
  } catch {}
}

export function currentOrganization() {
  return selection.value === "personal" ? "" : selection.value;
}

export function workspaceStorageKey(key, organization = currentOrganization()) {
  return organization ? `${key}:organization:${organization}` : key;
}

export function workspaceDestination(route, organization) {
  const workspace = organization.id;
  const query = { ...route.query };
  delete query.workspace;
  const sameWorkspace = selection.value === workspace;
  let path = route.path;
  if (!sameWorkspace) {
    if (/^\/organizations\/[^/]+\/settings$/.test(path)) {
      if (organization.role !== "admin")
        return { path: "/dashboard", query: {} };
      path = `/organizations/${workspace}/settings`;
    } else if (
      route.params?.routeId ||
      (["/dashboard", "/routes/new", "/planner"].includes(path) &&
        route.query.route)
    ) {
      return { path: "/dashboard", query: {} };
    }
  }
  return { path, query, ...(route.hash ? { hash: route.hash } : {}) };
}

export async function changeWorkspace(router, organization) {
  if (selection.value === organization.id) return;
  if (switching) throw new Error("A workspace change is already pending.");
  const selectedAccount = account;
  const destination = workspaceDestination(
    router.currentRoute.value,
    organization,
  );
  const fullPath = router.resolve(destination).fullPath;
  switching = true;
  const removeHook = router.afterEach((to, from, failure) => {
    if (failure || to.fullPath !== fullPath || account !== selectedAccount)
      return;
    selection.value = organization.id;
    if (!account) return;
    try {
      localStorage.setItem(
        `permitpilott:workspace:${account}`,
        organization.id,
      );
    } catch {}
  });
  try {
    return await router.push({ ...destination, force: true, replace: true });
  } finally {
    removeHook();
    switching = false;
  }
}
